import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { Book, Star } from 'lucide-react';

const Hero = () => {
  const [totalSubscribers, setTotalSubscribers] = useState<number | null>(null);
  const [loadingSubscribers, setLoadingSubscribers] = useState(true);

  useEffect(() => {
    const fetchTotalSubscribers = async () => {
      setLoadingSubscribers(true);
      try {
        const docRef = doc(db, 'socialStats', 'subscriberCounts');
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          const data = docSnap.data();
          const youtube = data.youtube || 0;
          const instagram = data.instagram || 0;
          const tiktok = data.tiktok || 0;
          const total = youtube + instagram + tiktok;
          setTotalSubscribers(total);
        } else {
          setTotalSubscribers(71000); // Valeur par défaut
        }
      } catch (err) {
        console.error("Erreur lors de la récupération des abonnés:", err);
        setTotalSubscribers(71000); // Valeur par défaut en cas d'erreur
      } finally {
        setLoadingSubscribers(false);
      }
    };

    fetchTotalSubscribers();
  }, []);

  const formatCount = (count: number | null): string => {
    if (count === null) return '71k';
    if (count >= 1000) {
      return `${Math.floor(count / 1000)}k`;
    }
    return `${count}`;
  };

  return (
    <div className="relative bg-white border-b-2 border-[#9a6ebd]/20">
      <div className="absolute inset-0">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FAccueil.jpg?alt=media&token=546c2a78-3cd1-4a1d-b1d1-127240be7a3d"
          alt="Students studying"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/95 to-white/80"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-36 pb-28 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-[#9a6ebd] bg-opacity-10 rounded-full px-4 py-2 flex items-center">
            <Star className="text-[#9a6ebd] w-5 h-5 mr-2" />
            <span className="text-[#9a6ebd] font-medium">
              Déjà + de {formatCount(totalSubscribers)} étudiants nous font confiance !
            </span>
          </div>
        </div>
        <h1 className="text-4xl tracking-tight font-extrabold text-[#323c5f] sm:text-5xl md:text-6xl">
          <span className="block">Comprendre les SES</span>
          <span className="block text-[#9a6ebd] text-3xl sm:text-4xl mt-3">
            Réussissez votre bac avec confiance 🎓
          </span>
        </h1>
        <p className="mt-3 max-w-md mx-auto text-base text-gray-600 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
          Des cours particuliers personnalisés et des ressources pédagogiques pour maîtriser 
          les Sciences Économiques et Sociales de façon simple et efficace ! 🚀
        </p>
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
          <Link
            to="/flashcards"
            className="rounded-full bg-white px-8 py-4 text-lg font-semibold text-[#9a6ebd] border-2 border-[#9a6ebd] hover:bg-gray-50 transition-colors flex items-center justify-center"
          >
            🎯 Flashcards SES
          </Link>
          <Link
            to="/ressources"
            className="rounded-full bg-white px-8 py-4 text-lg font-semibold text-[#9a6ebd] border-2 border-[#9a6ebd] hover:bg-gray-50 transition-colors flex items-center justify-center"
          >
            📚 Ressources gratuites
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Hero;